import { useEffect } from 'react';

interface AdUnitProps {
  slot: string | undefined;
  format?: string;
  className?: string;
  style?: React.CSSProperties;
  label?: string;
}

declare global {
  interface Window {
    adsbygoogle: unknown[];
  }
}

const clientId = import.meta.env.VITE_ADSENSE_CLIENT_ID as string | undefined;

export default function AdUnit({ slot, format = 'auto', className = '', style, label = 'Advertisement' }: AdUnitProps) {
  const configured = !!clientId && !!slot;

  useEffect(() => {
    if (!configured) return;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch {
      // adsbygoogle script not loaded (blocked, offline, or AdSense not approved yet); ignore
    }
  }, [configured, slot]);

  if (!configured) {
    return (
      <div
        className={`flex flex-col items-center justify-center gap-1 bg-ink-50 border border-dashed border-ink-200 rounded-lg text-ink-300 min-h-[100px] ${className}`}
        style={style}
      >
        <span className="text-[10px] uppercase tracking-wider">{label}</span>
        <span className="text-[9px]">Ad slot not configured</span>
      </div>
    );
  }

  return (
    <div className={className} style={style}>
      <p className="text-[10px] uppercase tracking-wider text-ink-300 mb-1 text-center">{label}</p>
      <ins
        className="adsbygoogle block"
        style={{ display: 'block' }}
        data-ad-client={clientId}
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive="true"
      />
    </div>
  );
}
